import React, { useRef, useState } from "react";
import { Input, Button } from "antd";
import { CheckOutlined, DeleteOutlined } from "@ant-design/icons";
import { BlockPicker } from "react-color";
import { audioMessage as message } from "@components/Common/Notifications/audioMessage";

// Inline create/edit editor for a custom status. Copied from v1 StatusUpdater; decoupled via
// onConfirm(mode, params) / onCancel callbacks and using audioMessage (AP-10).
export const StatusUpdater = ({ status, mode, statuses, onConfirm, onCancel }) => {
    const inputRef = useRef(null);
    const [statusColor, setStatusColor] = useState(status?.color || "#e2efdc");
    const [statusName, setStatusName] = useState(status?.name);
    const [displayColorPicker, setDisplayColorPicker] = useState(false);

    const confirm = () => {
        if (!statusName) {
            message.warning({ content: "Custom status name can't be blank", duration: 5 });
            return;
        }
        if (!statusColor) {
            message.warning({ content: "Custom status color can't be blank", duration: 5 });
            return;
        }

        const clash = statuses.filter((s) => {
            if (
                mode === "edit" &&
                (status?.status_id !== s?.status_id || status?.id !== s?.id) &&
                s.name.toLowerCase() === statusName.toLowerCase()
            ) {
                return s;
            } else if (mode !== "edit" && s.name.toLowerCase() === statusName.toLowerCase()) {
                return s;
            }
        });

        if (clash.length > 0) {
            message.warning({
                content:
                    clash[0].type === "built_in"
                        ? `This status name (${statusName}) is reserved and cannot be used.`
                        : `This status name (${statusName}) is already in use.`,
                duration: 5,
            });
            return;
        }

        onConfirm(mode, { id: status?.id ?? status?.status_id, name: statusName, color: statusColor });
        setStatusName(null);
        setStatusColor("#e2efdc");
    };

    const cancel = () => {
        setStatusName(null);
        setStatusColor("#e2efdc");
        onCancel();
    };

    const toggleColorPicker = () => setDisplayColorPicker((v) => !v);

    return (
        <div className="stv2-tracker-status-updater">
            <Input
                placeholder="Status Name"
                ref={inputRef}
                type="text"
                size="small"
                style={{ width: 130, height: 22 }}
                value={statusName}
                onChange={(e) => setStatusName(e.target.value)}
            />

            <div
                className="stv2-tracker-color-div-updater"
                style={{ backgroundColor: statusColor, cursor: "pointer" }}
                onClick={toggleColorPicker}
            ></div>

            {displayColorPicker && (
                <div style={{ position: "absolute", zIndex: 2 }}>
                    <div
                        style={{ position: "fixed", top: 0, right: 0, bottom: 0, left: 0 }}
                        onClick={toggleColorPicker}
                    />
                    <BlockPicker
                        color={statusColor}
                        onChangeComplete={(hex) => setStatusColor(hex.hex)}
                        colors={[
                            "#E2EFDC", "#FFE0B3", "#FFCCCC", "#E6FFEE", "#CDF5F6",
                            "#EFF9DA", "#F2F2F2", "#FFE6FF", "#FFFFCC", "#E6EEFF",
                        ]}
                    />
                </div>
            )}

            <Button
                type="primary"
                shape="circle"
                icon={<CheckOutlined />}
                className="stv2-create-status"
                onClick={confirm}
            />
            <Button
                type="primary"
                shape="circle"
                danger
                icon={<DeleteOutlined />}
                className="stv2-delete-status"
                onClick={cancel}
            />
        </div>
    );
};
